export const GET_PROFILE_EDIT_REQUESTS_REQUEST =
  "GET_PROFILE_EDIT_REQUESTS_REQUEST";

export const GET_PROFILE_EDIT_REQUESTS_RESPONSE =
  "GET_PROFILE_EDIT_REQUESTS_RESPONSE";
